// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/footer-back.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

:root {
    --navbar-Height: 80px;

    --bg-primary-Clr: #F25d2C;
    --bg-primary-clr: #1E4F6c;
    --text-primary-clr: #1E4F6c;
    --text-secondary-clr: #F25d2C;
    --text-black-Clr: #050505;
    --btn-primary-clr: #F25d2C;
    --btn-primary-HOVER: #d64717;
    --btn-secondary-clr: #1E4F6c;
    --btn-secondary-HOVER: #134664;
    --paragraph-font-size: 15px;
    --heading1-size: 4rem;
    --heading2-size: 3rem;

}

/* .footer-img img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-repeat: no-repeat;
    opacity: 0.2;

}
.footer-img::before{
    content: "";
    background-color:var(--bg-primary-clr);
    width: 100%;
    height: 100%;

} */

.footer-wrapper{
   
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 100%;
    height: auto;
    /* width: 100%;
    height:550px ; */
    /* background-color: var(--bg-primary-clr); */
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
    padding: 20px 30px 30px 30px;
    
}


.footer-heading{
    color: #81aec8;
    /* color:var(--bg-primary-Clr); */
    font-size: 48px;
    font-weight: 600;
    text-align: center;
}

.footer-body{
    /* border: 1px solid red;  */
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
    /* display: grid;
    grid-template-columns: repeat(2, 1fr); */
    
}
.footer-left,.footer-right{
    display: flex;
    flex-direction: column;
    padding: 10px ;
    color: white;
}
.footer-left{
    width: 40%;
    gap: 10px;
}
.footer-right{
    width: 60%;  
}

.footer-left h4,.footer-right h5,.footer-wrapper a, .footer-copyrights h5{
    text-decoration: none;
    font-weight: 400;
    color: white;
}

.location,.phone,.mobile,.mail{

    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 5px 0;

/* border: 1px solid red; */
}

.footer-copyrights,.followus-logo,.f-logo{
    display: flex;
    flex-direction:row ;
}
.footer-copyrights{
    justify-content: space-between;
}
 .f-logo, .followus-logo{
    gap: 10px;
}
.copyrights-text h5, .f-text h5{
    color: #81aec8;

}


.flex-row{
    width: 100%;
    display: flex;
    flex-direction: row;
  }


/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width:1023px) {

    .footer-left{
        gap: 0;
    }
    }
    
    /* Responsive For Tablet Screen size 601px to 1023px END */
    
    
    
    
    
    /* Responsive For Mobile Screen size 1024px to 1920px START */
    @media (max-width:767px) {
    
     
.footer-heading{
    font-size: 38px;
}
    .footer-body{
 
        display: flex;
        flex-direction: column;
        justify-content:center;
        padding: 0 0px;
        align-items: center;  
    }

    .footer-left,.footer-right{
        width: 100%;
        gap: 0px;

    }
    .footer-right{
        margin-top: -20px !important;
    }
    
    
.footer-copyrights,.followus-logo{
    display: flex;
    flex-direction: column;
}

.f-logo,.followus-logo{
    display: flex;
    flex-direction: row;
}

.footer-copyrights{
    justify-content: center;
}

.footer-wrapper h4,h5{
    font-size:12px ;
}
.footer-left{
    gap: 0;
}
.footer-copyrights{
    align-items: center;

}

    }
    
    /* Responsive For Mobile Screen size 1024px to 1920px END */`, "",{"version":3,"sources":["webpack://./src/Components/Footerstyles.css"],"names":[],"mappings":";;AAEA;IACI,qBAAqB;;IAErB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;IAC3B,qBAAqB;IACrB,qBAAqB;;AAEzB;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;;IAEI,yDAAkD;IAClD,WAAW;IACX,YAAY;IACZ;oBACgB;IAChB,6CAA6C;IAC7C,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;;AAEhC;;;AAGA;IACI,cAAc;IACd,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB;4CACwC;;AAE5C;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,YAAY;AAChB;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;;AAElB,2BAA2B;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;CACC;IACG,SAAS;AACb;AACA;IACI,cAAc;;AAElB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;;AAGF,4DAA4D;AAC5D;;IAEI;QACI,MAAM;IACV;IACA;;IAEA,0DAA0D;;;;;;IAM1D,6DAA6D;IAC7D;;;AAGJ;IACI,eAAe;AACnB;IACI;;QAEI,aAAa;QACb,sBAAsB;QACtB,sBAAsB;QACtB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,QAAQ;;IAEZ;IACA;QACI,4BAA4B;IAChC;;;AAGJ;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;AACA;IACI,MAAM;AACV;AACA;IACI,mBAAmB;;AAEvB;;IAEI;;IAEA,2DAA2D","sourcesContent":["\n\n:root {\n    --navbar-Height: 80px;\n\n    --bg-primary-Clr: #F25d2C;\n    --bg-primary-clr: #1E4F6c;\n    --text-primary-clr: #1E4F6c;\n    --text-secondary-clr: #F25d2C;\n    --text-black-Clr: #050505;\n    --btn-primary-clr: #F25d2C;\n    --btn-primary-HOVER: #d64717;\n    --btn-secondary-clr: #1E4F6c;\n    --btn-secondary-HOVER: #134664;\n    --paragraph-font-size: 15px;\n    --heading1-size: 4rem;\n    --heading2-size: 3rem;\n\n}\n\n/* .footer-img img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    background-repeat: no-repeat;\n    opacity: 0.2;\n\n}\n.footer-img::before{\n    content: \"\";\n    background-color:var(--bg-primary-clr);\n    width: 100%;\n    height: 100%;\n\n} */\n\n.footer-wrapper{\n   \n    background-image: url(\"../Assets/footer-back.jpg\");\n    width: 100%;\n    height: auto;\n    /* width: 100%;\n    height:550px ; */\n    /* background-color: var(--bg-primary-clr); */\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: bottom;\n    padding: 20px 30px 30px 30px;\n    \n}\n\n\n.footer-heading{\n    color: #81aec8;\n    /* color:var(--bg-primary-Clr); */\n    font-size: 48px;\n    font-weight: 600;\n    text-align: center;\n}\n\n.footer-body{\n    /* border: 1px solid red;  */\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 0 20px;\n    align-items: center;\n    /* display: grid;\n    grid-template-columns: repeat(2, 1fr); */\n    \n}\n.footer-left,.footer-right{\n    display: flex;\n    flex-direction: column;\n    padding: 10px ;\n    color: white;\n}\n.footer-left{\n    width: 40%;\n    gap: 10px;\n}\n.footer-right{\n    width: 60%;  \n}\n\n.footer-left h4,.footer-right h5,.footer-wrapper a, .footer-copyrights h5{\n    text-decoration: none;\n    font-weight: 400;\n    color: white;\n}\n\n.location,.phone,.mobile,.mail{\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 5px 0;\n\n/* border: 1px solid red; */\n}\n\n.footer-copyrights,.followus-logo,.f-logo{\n    display: flex;\n    flex-direction:row ;\n}\n.footer-copyrights{\n    justify-content: space-between;\n}\n .f-logo, .followus-logo{\n    gap: 10px;\n}\n.copyrights-text h5, .f-text h5{\n    color: #81aec8;\n\n}\n\n\n.flex-row{\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n  }\n\n\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width:1023px) {\n\n    .footer-left{\n        gap: 0;\n    }\n    }\n    \n    /* Responsive For Tablet Screen size 601px to 1023px END */\n    \n    \n    \n    \n    \n    /* Responsive For Mobile Screen size 1024px to 1920px START */\n    @media (max-width:767px) {\n    \n     \n.footer-heading{\n    font-size: 38px;\n}\n    .footer-body{\n \n        display: flex;\n        flex-direction: column;\n        justify-content:center;\n        padding: 0 0px;\n        align-items: center;  \n    }\n\n    .footer-left,.footer-right{\n        width: 100%;\n        gap: 0px;\n\n    }\n    .footer-right{\n        margin-top: -20px !important;\n    }\n    \n    \n.footer-copyrights,.followus-logo{\n    display: flex;\n    flex-direction: column;\n}\n\n.f-logo,.followus-logo{\n    display: flex;\n    flex-direction: row;\n}\n\n.footer-copyrights{\n    justify-content: center;\n}\n\n.footer-wrapper h4,h5{\n    font-size:12px ;\n}\n.footer-left{\n    gap: 0;\n}\n.footer-copyrights{\n    align-items: center;\n\n}\n\n    }\n    \n    /* Responsive For Mobile Screen size 1024px to 1920px END */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
